import { useState } from "react";
import { URLS } from "../config/url";
import { useNavigate } from "react-router-dom";

export const useLogin = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [message, setMessage] = useState(null);

  const login = async (email, password) => {
    setLoading(true);
    setError(null);
    setMessage(null);

    try {
      const response = await fetch(`${URLS}/api/user/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, password }),
      });

      const json = await response.json();

      if (!response.ok) {
        throw new Error(json.error || "Login failed");
      }

      // Store tokens and expiration time (3 minutes from now)
      const accessTokenExpires = Date.now() + 3 * 60 * 1000; // 3 minutes in milliseconds
      localStorage.setItem("accessToken", json.accessToken);
      localStorage.setItem("refreshToken", json.refreshToken);
      localStorage.setItem("accessTokenExpires", accessTokenExpires.toString());
      localStorage.setItem("userEmail", json.email);

      setMessage("Login successful!");
      setTimeout(() => navigate("/"), 2000);
    } catch (err) {
      setError(err.message || "An error occurred during login");
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    error,
    message,
    login,
  };
};
